export default __webpack_public_path__ + "static/media/laundry2-before-1440w.586329f7.webp";